import type { SVGProps } from 'react';

export function BranchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 36C20 36 24 28 28 22C32 16 38 12 48 14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
      <path d="M28 22L20 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M28 22L26 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M40 16L36 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M44 14L48 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M48 14L54 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <circle cx="48" cy="14" r="3" stroke="currentColor" strokeWidth="2" fill="none" />
    </svg>
  );
}
